import { useEffect, useRef, useState } from "react";
import { ModalWrapper, ModalContainer } from "../Dashboard/Dashboard.style";
import { Header } from "./Modal.style";
import { ButtonWrapper, Button } from "../Dashboard/Dashboard.style";

export default function ArrangerBoard({ data, saveList, setModal }) {
  const [arrangeData, setArrangeData] = useState({
    name: "",
    title: "",
    items: [],
  });
  const draggedItemIndexRef = useRef(-1);
  const [loading,setLoading] = useState(false);

  const handleDragStart = (index) => {
    draggedItemIndexRef.current = index;
    console.log("Dragging", index);
    //setDraggedItemIndex(index);
  };

  // Handle drag over (to allow drop)
  const handleDragOver = (e) => {
    e.preventDefault(); // Prevent default to allow drop
  };

  const handleDrop = async (index) => {
    const [movedItem] = arrangeData.items.splice(
      draggedItemIndexRef.current,
      1
    );
    arrangeData.items.splice(index, 0, movedItem);
    setArrangeData({ ...arrangeData });
    draggedItemIndexRef.current = -1;
  };

  async function save() {
    if(loading) return;
    setLoading(true);
    try {
      const priorityList = arrangeData.items.map((item, index) => {
        return {
          id: item._id,
          index,
        };
      });
      await saveList(priorityList, arrangeData);
      setModal(false);
    } catch (err) {
      alert("Something went wrong");
    }
    setLoading(false);
  }

  useEffect(() => {
    setArrangeData({ ...data[0] });
  }, [data]);

  return (
    <ModalWrapper>
      <ModalContainer width={"95%"} height={"95%"}>
        <div
          style={{
            display: "flex",
            height: "100%",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Header>
            <h2>Arrange {arrangeData.title}</h2>
            <h2 onClick={() => setModal(false)} style={{ cursor: "pointer" }}>
              ×
            </h2>
          </Header>
          <div>
            <h6 style={{ fontWeight: "bold", fontSize: "0.8rem" }}>
              Choose Data To Arrange
            </h6>
            <div style={{ display: "flex", gap: "20px" }}>
              {data.map((list) => {
                return (
                  <div style={{ margin: "10px 0", display: "flex" }}>
                    <input
                      type="radio"
                      name="exportType"
                      onChange={() => setArrangeData(list)}
                      style={{ display: "block", margin: "auto 20px auto 0" }}
                      checked={arrangeData.id === list.id}
                    />
                    <label style={{ fontSize: "1.1rem" }}>{list.title}</label>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            style={{
              display: "grid",
              justifyContent: "flex-start",
              gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr 1fr",
              gap: "10px",
              overflow:"auto"
            }}
          >
            {arrangeData.items.map((item, index) => {
              return (
                <div
                  key={index}
                  draggable={!loading}
                  onDrag={() => handleDragStart(index)}
                  onDragOver={handleDragOver}
                  onDrop={() => handleDrop(index)}
                  style={{
                    display: "flex",
                    width: "100%",
                    minHeight: "80px",
                    maxHeight: "fit-content",
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px",
                    borderRadius: "10px",
                    boxShadow: "1px 1px 3px #c7c6c1",
                    backgroundColor: "#ededed",
                    opacity:item.disabled?0.5:1
                  }}
                >
                  <h3
                    style={{
                      fontSize: "1rem",
                      wordBreak: "break-all",
                      fontWeight: "600",
                    }}
                  >
                    {item.name}
                  </h3>
                </div>
              );
            })}
          </div>
          <ButtonWrapper style={{ width: "50%", margin: "auto auto 0 auto" }}>
            <Button disabled={loading} onClick={() => setModal(false)}>CANCEL</Button>
            <Button disabled={loading} onClick={save}>{loading ? "SAVING...":"SAVE"}</Button>
          </ButtonWrapper>
        </div>
      </ModalContainer>
    </ModalWrapper>
  );
}
